// leave off @2x/@3x
import arrowBack from '../resources/image/back@1.5x.png';
import currentPin from '../resources/image/current_pin.png';
import gps from '../resources/image/gps.png';
import overviewImage from '../resources/image/Googlebusiness.png';
import success from '../resources/image/success.png';
import unsuccess from '../resources/image/unsuccess.png';
import empty from '../resources/image/empty.png';
import error from '../resources/image/error.png';
import deletes from '../resources/image/delete.png';
import down from '../resources/image/down.png';
import check from '../resources/image/check.png';
import stop from '../resources/image/stop.png';
import edit from '../resources/image/edit.png';
import iconLoading from '../resources/image/icon-loading-flower.gif';
import step1 from '../resources/image/landing/step1.png';
import step2 from '../resources/image/landing/step2.png';
import step3 from '../resources/image/landing/step3.png';
import step4 from '../resources/image/landing/step4.png';
import step5 from '../resources/image/landing/step5.png';
import step6 from '../resources/image/landing/step6.png';
import alert from '../resources/image/alert.png';
import redAlert from '../resources/image/red-alert.png';
import logo from '../resources/image/logo.png';
import branchdefault from '../resources/image/branchdefault.png';
import menudefault from '../resources/image/menudefault.png';
import menudefault2 from '../resources/image/menudefault2.png';
import menuTableDefault from '../resources/image/menuTableDefault.jpg';
import productDefault from '../resources/image/productDefault.png';
import productDefault2 from '../resources/image/productDefault2.png';
import menuIcon from '../resources/image/menuIcon.png';
import promotion from '../resources/image/promotion.png';
import bg from '../resources/image/landing/bg.png';
import arrowSwitch from '../resources/image/arrow-switch.png';
import logoIcon from '../resources/image/logo_icon.png';
import logoIcon2 from '../resources/image/logo-rbh-food-icon.png';
import back from '../resources/image/back.png';
import close from '../resources/image/close.png';
import posIcon from '../resources/image/posIcon.png';
import asterisk from '../resources/image/asterisk.png';
import chef from '../resources/image/chef.png';
import mainMart from '../resources/image/main-mart.png';
import emptyState from '../resources/image/emptyState.png';
import foodIcon from '../resources/image/food_icon.png';
import martIcon from '../resources/image/mart_icon.png';
import shopIcon from '../resources/image/shop-icon.png';
import pinMap from '../resources/image/shop/pin-map.png';

import loginBgImage2 from '../resources/image/bg-login-2.jpg';
import banner from '../resources/image/banner.png';
import logoRbhShop from '../resources/image/svg/logo_icon.shop.svg'
import eye from '../resources/image/svg/eye.svg'
import eyeClose from '../resources/image/svg/eye-close.svg'
import promotionTag from '../resources/image/svg/promotion-tag.svg'

const images = {
  arrowBack,
  overviewImage,
  gps,
  currentPin,
  success,
  unsuccess,
  empty,
  error,
  down,
  deletes,
  check,
  stop,
  edit,
  iconLoading,
  landingStep: {
    step1,
    step2,
    step3,
    step4,
    step5,
    step6,
  },
  arrowSwitch,
  alert,
  logo,
  branchdefault,
  menudefault,
  menudefault2,
  menuTableDefault,
  menuIcon,
  promotion,
  bg,
  logoIcon,
  logoIcon2,
  back,
  close,
  posIcon,
  asterisk,
  redAlert,
  chef,
  mainMart,
  emptyState,
  productDefault,
  productDefault2,
  foodIcon,
  martIcon,
  shopIcon,
  loginBgImage2,
  banner,
  logoRbhShop,
  eye,
  eyeClose,
  promotionTag,
  pinMap
};

export default images;
